import currencyFormatter from "../../../Helpers/currencyFormatter";
import money from '../../../favicon/money.png'
import EmptyItem from "../../comman/EmptyItem";

const History = ({ ...props }) => {

  const { data } = props;
  return (
    <>


      <div className="container mx-auto">
        <div className='' >
          <>
          {data?.length > 0 ?(data?.map((item, i) => (
            <div key={item?.id} className="p-2  my-2 rounded-lg "
              style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >

              <div className='flex flex-col md:flex-row ' >
                <img src={money} alt={'money'} className="w-[118px] h-[68px] rounded-lg " ></img>

                <div className=' w-full flex lg:flex-row flex-col  justify-between md:mx-4 ' >

                  <div className='flex flex-col  justify-between  h-full ' >
                    <div>
                      <h4 className='tracking-wider text-[#178ACB]' >RM {currencyFormatter.format(item?.amount)}<span className=' ml-1 text-[8px]  sm:text-xs  text-gray-500 font-museo tracking-normal ' >Total request</span></h4>
                    </div>
                  </div>
                </div>
                <div className='flex items-center sm:my-0 my-2 justify-center sm:justify-end sm:py-0 py-1 ' >
                  <span className={`items-center grid  text-white font-museobb ${item?.status == 'Completed' ? 'bg-green-500 ': 'bg-red-500 ' }text-center md:text-sm text-xs tracking-widest rounded-full w-[130px] h-[30px] sm:w-[160px] sm:h-[33px]  lg:w-[200px] lg:h-[41px] `} >{item?.status?.toUpperCase()}</span>
                </div>
              </div>
            </div>
          ))):(
                 <EmptyItem text={'No withdraw history found'} />
          )}
          </>
        </div>

      </div>

    </>

  )



}

export default History;